// import React from 'react';
// import ReactDOM from 'react-dom';
// import './index.scss';
// import App from './App';
// import GlobalContextProvider from './components/context/GlobalContext';
// import "bootstrap/dist/css/bootstrap.min.css";
// // import "font-awesome/css/font-awesome.min.css";


// ReactDOM.render(
//   <React.StrictMode>
//   <GlobalContextProvider>
//     <App />
//   </GlobalContextProvider>
//   </React.StrictMode>,
//   document.getElementById('root')
// );

import React from 'react';
// import ReactDOM from 'react-dom';
import { hydrate, render } from 'react-dom';
import './index.scss';
import App from './App';
import GlobalContextProvider from './components/context/GlobalContext';
import "bootstrap/dist/css/bootstrap.min.css";

const rootElement = document.getElementById("root");

const app = (
  <React.StrictMode>
    <GlobalContextProvider>
      <App />
    </GlobalContextProvider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  hydrate(app, rootElement); // for SSR / pre-rendered HTML
} else {
  render(app, rootElement);  // for normal SPA
}